import { TextField, InputAdornment, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface HeroVideoSearchFieldProps {
  value: string;
  isSearching: boolean;
  onChange: (query: string) => void;
}

export function HeroVideoSearchField({ value, isSearching, onChange }: HeroVideoSearchFieldProps) {
  return (
    <TextField
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Sök efter video..."
      fullWidth
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        endAdornment: isSearching ? (
          <InputAdornment position="end">
            <CircularProgress size={18} />
          </InputAdornment>
        ) : null,
      }}
    />
  );
}
